import { Collection } from '@generated/graphql/types';

/**
 * Returns the path to the collection. Can be used for the href prop in Nextjs' Link component.
 * @param  {Collection['handle']} handle The product handle provided by Shopify.
 */
export const getCollectionPath = (handle: Collection['handle']) => `/collections/${handle}`;
